import store from "../store/index";

const CLASSES = {
  externalLink: "link__external",
  externalLinkIcon: "link__external-icon",
};

const TYPES = {
  richText: "rich_text",
};

class ExternalLink {
  constructor(context, type) {
    this.context = context;
    this.type = type;
  }

  init() {
    this.ExternalLinkString = Drupal.t("external link");

    if (this.type == TYPES.richText) {
      this.processRichTextExternalLink();
    }
  }

  addExternalRel() {
    const linkTypes = (this.context.getAttribute("rel") || "").split(" ");
    if (!linkTypes.includes("external")) {
      linkTypes.push("external");
    }
    this.context.setAttribute("rel", linkTypes.join(" ").trim());
  }

  addExternalClass() {
    const linkClasses = (this.context.getAttribute("class") || "").split(" ");
    if (!linkClasses.includes(CLASSES.externalLink)) {
      linkClasses.push(CLASSES.externalLink);
    }
    this.context.setAttribute("class", linkClasses.join(" ").trim());
  }

  addExternalIcon() {
    if (!this.context.querySelector(`.${CLASSES.externalLinkIcon}`)) {
      this.context.insertAdjacentHTML(
        "beforeend",
        `<i class="material-icons ${CLASSES.externalLinkIcon}" title="${this.ExternalLinkString}" role="presentation" aria-hidden="true">north_east</i>`,
      );
    }
  }

  addExternalSRText() {
    if (!this.context.querySelector(".sr-only")) {
      this.context.insertAdjacentHTML(
        "beforeend",
        `<span class="sr-only">${this.ExternalLinkString}</span>`,
      );
    }
  }

  processRichTextExternalLink() {
    this.addExternalClass();
    this.addExternalRel();
    this.addExternalIcon();
    this.addExternalSRText();
  }
}

export { ExternalLink };
